// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");
require("./chart2");

var Chartist = require("chartist");
var $ = require("jquery");

function commafy(num) {
  num = num.toString();
  if (!num) return;
  if (num.length >= 4) {
    num = num.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  }
  return num;
}



var data = {
  labels: ["’00", "’01", "’02", "’03", "’04", "’05", "’06", "’07", "’08", "’09", "’10", "’11", "’12", "’13", "’14"],
  series: [{
    name: 'Sales',
    data: [13267451, 13474733, 13133814, 13033391, 13580750, 14087193, 15100793, 15791179, 15840735, 14421862, 14005431, 14808889, 14596586, 15012412, 15210264]
  }, {
    name: 'Other',
    data: [3949863, 3515676, 3535895, 3685293, 3788433, 3868764, 4100050, 4393639, 3915082, 3626427, 3550277, 3472695, 3556870, 4150519, 4237635]
  }]
}
var options = {
  // Default mobile configuration
  stackBars: true,

  axisY: {
    // labelInterpolationFnc: function(value) {
    //   return ("$" + (value / 1000000) + "b");
    // },
    type: Chartist.FixedScaleAxis,
   ticks: [0, 5000000, 10000000, 15000000, 20000000, 25000000],
   low: 0,
   labelInterpolationFnc: function(value) {
     return "$" + (value / 1000000) + 'b';
   },

    labelOffset: {
      x: 6,
      y: 6
    }
  },
  axisX: {
    labelInterpolationFnc: function(value, index) {
      return index % 1 === 0 ? value : null;
    }
  },

  labelOffset: 50,
  labelDirection: 'explode'
};



var $chart = $('#chart1');

var $toolTip = $chart
  .append('<div class="tooltip"></div>')
  .find('.tooltip')
  .hide();

$chart.on('mouseenter', '.ct-bar', function() {
  var $bar = $(this),
    value = $bar.attr('ct:value'),
    seriesName = $bar.parent().attr('ct:series-name');
  $toolTip.html('<span class="popuptitle">' + seriesName + '</span><br><div class="popuptext">$' + ((value / 1000000).toFixed(1)) + ' billion</div>').show();
});

$chart.on('mouseleave', '.ct-bar', function() {
  $toolTip.hide();
});

$chart.on('mousemove', function(event) {
  $toolTip.css({
    left: (event.offsetX || event.originalEvent.layerX) - $toolTip.width() / 2 - 10,
    top: (event.offsetY || event.originalEvent.layerY) - $toolTip.height() - 40
  });
});

new Chartist.Bar('#chart1', data, options);
